import {
  API_PATHS,
  type StandingFallbacks,
  standingFallbacksSchema,
} from '@alphadesk/web/contract.ts';
import { useFreshRead } from './reads.ts';

const NOT_ASKED: StandingFallbacks = { readable: false, fallbacks: [], asOf: '' };

export function useStandingFallbacks(ask: boolean): {
  answer: StandingFallbacks;
  refresh: () => void;
} {
  // A stale map would state fallback stops that may be gone, so a failed read is not-asked.
  // `readable: false` means "not asked", never "nothing is armed".
  const { answer, refresh } = useFreshRead(
    ask,
    API_PATHS.fallbacks,
    standingFallbacksSchema,
    NOT_ASKED,
  );
  // Re-parking a fallback sends no socket frame, so callers refresh after acting.
  return { answer, refresh };
}
